import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useHideTimer = function useHideTimer(_ref) {
  var duration = _ref.duration,
    showing = _ref.showing;
  var _React$useState = React.useState(showing),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showingState = _React$useState2[0],
    setShowingState = _React$useState2[1];
  var hideTimer = React.useRef(null);
  var clearHideTimer = function clearHideTimer() {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
    }
  };
  React.useEffect(function () {
    setShowingState(showing);
    if (!showing) {
      clearHideTimer();
      return;
    }
    if (duration === 0) {
      return;
    }
    hideTimer.current = setTimeout(function () {
      setShowingState(false);
    }, duration);
    return function () {
      return clearHideTimer();
    };
  }, [showing, duration]);
  return {
    showingState: showingState
  };
};

export { useHideTimer };
